import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " Ingrese el correo electrónico con el cual se ha registrado en nuestra plataforma. ", -1)
const _hoisted_2 = {
  key: 0,
  class: "items-center text-center flex flex-col"
}
const _hoisted_3 = { class: "text-primary-400" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Recuperar contraseña",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = e => _ctx.$emit('update:visible', e))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleForgorPassword())),
        disabled: _ctx.loadingResponse,
        class: "text-primary-400 font-bold underline-offset-1 underline"
      }, " Enviar correo de recuperación ", 8, _hoisted_4)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_TextField, {
        label: "Correo de recuperación",
        name: "passwordRecovery",
        type: "string",
        model: _ctx.email,
        "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
      }, null, 8, ["model"]),
      (_ctx.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createVNode(_component_mdicon, { name: "check-circle" })
            ]),
            _createTextVNode(" Te enviamos un enlace para restablecer tu contraseña. Si no lo ves, revisa tu carpeta de spam. ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}